import React from 'react';
import { Layout } from '@/components/Layout';
import { PageHeader } from '@/components/PageHeader';
import { AnalyticsVault } from '@/components/analytics/AnalyticsVault';
import { useEnhancedMobile } from '@/hooks/use-enhanced-mobile';

const AnalyticsVaultPage = () => {
  const { isMobile } = useEnhancedMobile();

  return (
    <Layout>
      <PageHeader title="Analytics Vault." subtitle="Track your social media performance and generate reports" />
      <div className={`container mx-auto max-w-[1200px] overflow-x-hidden ${isMobile ? 'px-2 py-2' : 'px-6 py-6'}`}>
        <AnalyticsVault />
      </div>
    </Layout>
  );
};

export default AnalyticsVaultPage;